import { render, staticRenderFns } from "./ProjectNavbar.vue?vue&type=template&id=48bb7677&scoped=true&"
import script from "./ProjectNavbar.vue?vue&type=script&lang=js&"
export * from "./ProjectNavbar.vue?vue&type=script&lang=js&"
import style0 from "./ProjectNavbar.vue?vue&type=style&index=0&id=48bb7677&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bb7677",
  null
  
)

export default component.exports